import { render } from "./SelectionChatUser.vue?vue&type=template&id=468bfe5e"
import script from "./SelectionChatUser.vue?vue&type=script&lang=js"
export * from "./SelectionChatUser.vue?vue&type=script&lang=js"
script.render = render

export default script